// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function() {
    'use strict';
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] ||
            window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function(callback) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }
    if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
    }
}());

/**
 * jQuery "splendid textchange" plugin
 * http://benalpert.com/2013/06/18/a-near-perfect-oninput-shim-for-ie-8-and-9.html
 *
 * (c) 2013 Ben Alpert, released under the MIT license
 */

(function($) {
    'use strict';

    /**
     * https://github.com/2is10/selectionchange-polyfill
     */
    var selectionchange = (function(undefined) { // eslint-disable-line no-shadow-restricted-names
        var SELECT_ALL_MODIFIER = /^Mac/.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
        var RANGE_PROPS = ['startContainer', 'startOffset', 'endContainer', 'endOffset'];

        var ranges;

        function hasNativeSupport(doc) {
            var osc = doc.onselectionchange;
            if (osc !== undefined) {
                try {
                    doc.onselectionchange = 0;
                    return doc.onselectionchange === null;
                } catch (e) {
                    // nothing to do
                } finally {
                    doc.onselectionchange = osc;
                }
            }
            return false;
        }

        function newWeakMap() {
            if (typeof WeakMap !== 'undefined') { // eslint-disable-line no-undef
                return new WeakMap(); // eslint-disable-line no-undef
            } else {
                return null;
            }
        }

        function getSelectionRange(doc) {
            var s = doc.getSelection();
            return s.rangeCount ? s.getRangeAt(0) : null;
        }

        function on(el, eventType, handler) {
            el.addEventListener(eventType, handler, true);
        }

        function off(el, eventType, handler) {
            el.removeEventListener(eventType, handler, true);
        }

        function onKeyDown(e) {
            var code = e.keyCode;
            if (code === 65 && e[SELECT_ALL_MODIFIER] && !e.shiftKey && !e.altKey || // Ctrl-A or Cmd-A
                (code <= 40 && code >= 37) && e.shiftKey) { // (Alt-)Shift-arrow
                setTimeout(dispatchIfChanged.bind(null, e.currentTarget), 0);
            }
        }

        function onMouseDown(e) {
            if (e.button === 0) {
                on(e.currentTarget, 'mousemove', onMouseMove);
                setTimeout(dispatchIfChanged.bind(null, e.currentTarget), 0);
            }
        }

        function onMouseMove(e) { // only needed while primary button is down
            if (e.buttons && 1) {
                dispatchIfChanged(e.currentTarget);
            } else {
                off(e.currentTarget, 'mousemove', onMouseMove);
            }
        }

        function onMouseUp(e) {
            if (e.button === 0) {
                setTimeout(dispatchIfChanged.bind(null, e.currentTarget), 0);
            } else {
                off(e.currentTarget, 'mousemove', onMouseMove);
            }
        }

        function onFocus() {
            setTimeout(dispatchIfChanged.bind(null, document), 0);
        }

        function dispatchIfChanged(doc) {
            var rOld = ranges.get(doc);
            var rNew = getSelectionRange(doc);
            if (!sameRange(rNew, rOld)) {
                ranges.set(doc, rNew);
                setTimeout(doc.dispatchEvent.bind(doc, new Event('selectionchange')), 0);
            }
        }

        function sameRange(r1, r2) {
            return r1 === r2 || r1 && r2 && RANGE_PROPS.every(function(prop) {
                return r1[prop] === r2[prop];
            });
        }

        return {
            start: function(doc) {
                var d = doc || document;
                if (ranges || !hasNativeSupport(d) && (ranges = newWeakMap())) {
                    if (!ranges.has(d)) {
                        ranges.set(d, getSelectionRange(d));
                        on(d, 'keydown', onKeyDown);
                        on(d, 'mousedown', onMouseDown);
                        on(d, 'mousemove', onMouseMove);
                        on(d, 'mouseup', onMouseUp);
                        on(d.defaultView, 'focus', onFocus);
                    }
                }
            },
            stop: function(doc) {
                var d = doc || document;
                if (ranges && ranges.has(d)) {
                    ranges['delete'](d);
                    off(d, 'keydown', onKeyDown);
                    off(d, 'mousedown', onMouseDown);
                    off(d, 'mousemove', onMouseMove);
                    off(d, 'mouseup', onMouseUp);
                    off(d.defaultView, 'focus', onFocus);
                }
            },
        };
    })();

    var isOldFirefox = (function() {
        var myRegexp = /Firefox\/(\d+)/g;
        var match = myRegexp.exec(navigator.userAgent);
        return match && match.length > 1 && parseInt(match[1], 10) < 10;
    })();

    /**
     * End: https://github.com/2is10/selectionchange-polyfill
     */

    var testNode = document.createElement('input');
    var isInputSupported = 'oninput' in testNode &&
        (!('documentMode' in document) || document.documentMode > 9);

    var hasInputCapabilities = function(elem) {
        // The HTML5 spec lists many more types than `text` and `password` on
        // which the input event is triggered but none of them exist in IE 8 or
        // 9, so we don't check them here.
        // TODO: <textarea> should be supported too but IE seems to reset the
        // selection when changing textarea contents during a selectionchange
        // event so it's not listed here for now.
        return elem.nodeName === 'INPUT' &&
            (elem.type === 'text' || elem.type === 'password');
    };

    var activeElement = null;
    var activeElementValue = null;
    var activeElementValueProp = null;

    /**
     * (For old IE.) Replacement getter/setter for the `value` property that
     * gets set on the active element.
     */
    var newValueProp = {
        get: function() {
            return activeElementValueProp.get.call(this);
        },
        set: function(val) {
            activeElementValue = val;
            activeElementValueProp.set.call(this, val);
        },
    };

    /**
     * (For old IE.) Starts tracking propertychange events on the passed-in element
     * and override the value property so that we can distinguish user events from
     * value changes in JS.
     * @param {object} target
     */
    var startWatching = function(target) {
        activeElement = target;
        activeElementValue = target.value;
        // This method is not supported by old browsers still present in the market, like firefox 3.6 / 4
        if (!isOldFirefox) {
            activeElementValueProp = Object.getOwnPropertyDescriptor(
                target.constructor.prototype, 'value');

            Object.defineProperty(activeElement, 'value', newValueProp);
            activeElement.attachEvent('onpropertychange', handlePropertyChange);
        }
    };

    /**
     * (For old IE.) Removes the event listeners from the currently-tracked
     * element, if any exists.
     */
    var stopWatching = function() {
        if (!activeElement) {
            return;
        }
        if (!isOldFirefox) {
            // delete restores the original property definition
            delete activeElement.value;
            if (activeElement.detachEvent) {
                activeElement.detachEvent('onpropertychange', handlePropertyChange);
            } else if (activeElement.removeEventListener) {
                activeElement.removeEventListener('onpropertychange', handlePropertyChange, true);
            }
        }
        activeElement = null;
        activeElementValue = null;
        activeElementValueProp = null;
    };

    /**
     * (For old IE.) Handles a propertychange event, sending a textChange event if
     * the value of the active element has changed.
     * @param {object} nativeEvent
     */
    var handlePropertyChange = function(nativeEvent) {
        if (nativeEvent.propertyName !== 'value') {
            return;
        }

        var value = nativeEvent.srcElement.value;
        if (value === activeElementValue) {
            return;
        }
        activeElementValue = value;

        $(activeElement).trigger('textchange');
    };

    if (isInputSupported) {
        $(document)
            .on('input', function(e) {
                // In modern browsers (i.e., not IE 8 or 9), the input event is
                // exactly what we want so fall through here and trigger the
                // event...
                if (e.target.nodeName !== 'TEXTAREA') {
                    // ...unless it's a textarea, in which case we don't fire an
                    // event (so that we have consistency with our old-IE shim).
                    $(e.target).trigger('textchange');
                }
            });
    } else {
        $(document)
            .on('focusin', function(e) {
                // In IE 8, we can capture almost all .value changes by adding a
                // propertychange handler and looking for events with propertyName
                // equal to 'value'.
                // In IE 9, propertychange fires for most input events but is buggy
                // and doesn't fire when text is deleted, but conveniently,
                // selectionchange appears to fire in all of the remaining cases so
                // we catch those and forward the event if the value has changed.
                // In either case, we don't want to call the event handler if the
                // value is changed from JS so we redefine a setter for `.value`
                // that updates our activeElementValue variable, allowing us to
                // ignore those changes.
                if (hasInputCapabilities(e.target)) {
                    // stopWatching() should be a noop here but we call it just in
                    // case we missed a blur event somehow.
                    stopWatching();
                    startWatching(e.target);
                }
            })

            .on('focusout', function() {
                stopWatching();
            })

            .on('selectionchange keyup keydown', function() {
                // On the selectionchange event, e.target is just document which
                // isn't helpful for us so just check activeElement instead.
                //
                // 90% of the time, keydown and keyup aren't necessary. IE 8 fails
                // to fire propertychange on the first input event after setting
                // `value` from a script and fires only keydown, keypress, keyup.
                // Catching keyup usually gets it and catching keydown lets us fire
                // an event for the first keystroke if user does a key repeat
                // (it'll be a little delayed: right before the second keystroke).
                // Other input methods (e.g., paste) seem to fire selectionchange
                // normally.
                if (!isOldFirefox) {
                    if (activeElement && activeElement.value !== activeElementValue) {
                        activeElementValue = activeElement.value;
                        $(activeElement).trigger('textchange');
                    }
                } else if (activeElement) {
                    $(activeElement).trigger('textchange');
                }
            });
    }

    if (isOldFirefox) {
        selectionchange.start();
    }
})(jQuery);

// CustomEvent polyfill.
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
(function() {
    if ( typeof window.CustomEvent === 'function' ) return false;

    function CustomEvent(event, params) {
        params = params || {bubbles: false, cancelable: false, detail: null};
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }

    window.CustomEvent = CustomEvent;
})();
